<p-card [styleClass]="'backgroundEbemLighterGreen'">
    <p>{{text}}</p>
    @if(showAvatar) {
        <div class="row justify-content-start">
            <div class="col-3">
                <p-avatar [image]="avatarSrc" size="xlarge" shape="circle"></p-avatar>
            </div>
            <div class="col-9">
                <h6>{{avatarName}}</h6>
                <small style="color:gray">{{avatarTitle}}</small>
            </div>
        </div>
    }
</p-card>